export enum CasinoClientPlatform {
  Windows = 1,
  Macintosh = 2,
  iOS = 3,
  Android = 4,
  Web = 5,
  MobileWeb = 8
}
